import styled from 'styled-components';

export const PlaceholderBox = ({ text, height, ...props }) => {
  return (
    <PlaceholderBoxStyle {...props} height={height} dangerouslySetInnerHTML={{ __html: text }} />
  );
};

const PlaceholderBoxStyle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  background: ${({ backgroundColor }) => backgroundColor || '#f8f9fa'};
  border-radius: 8px;
  text: #adb5bd;
  color: #adb5bd;
  text-align: center;
  width: 100%;
  height: ${({ height }) => height || '300px'};
  // min-height: 168px;
  min-height: 34px;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 140%; /* 19.6px */
  transition: 0.1s ease-in-out all;
`;
